import TextWithLottie from '@/components/elements/TextWithLottie';
import { Button, List, ListIcon, ListItem } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import React from 'react';
import { BiCheck } from 'react-icons/bi';
import * as animation from './data.json';

const LandingLottieThree = () => {
  const { t } = useTranslation(`landing`);
  return (
    <TextWithLottie
      title={t(`landing_lottie_three.header`)}
      lead={t(`landing_lottie_three.lead`)}
      animationData={(animation as any).default}
      alternativeImage="/images/landing/landing-lottie-3.svg"
    >
      <>
        <List spacing={3} listStylePos="outside">
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_three.list_items.one`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_three.list_items.two`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_three.list_items.three`)}
          </ListItem>
          <ListItem display="flex">
            <ListIcon ms="-7" boxSize="6" as={BiCheck} color="#74c4cb" />
            {t(`landing_lottie_three.list_items.four`)}
          </ListItem>
        </List>
        <Link href="/features#how-it-works" passHref>
          <Button
            mt={12}
            as="a"
            w="fit-content"
            me={[0, null, 12]}
            variant="solid-brand-cta"
          >
            {t(`landing_lottie_three.buttons.action_one`)}
          </Button>
        </Link>
      </>
    </TextWithLottie>
  );
};

export default LandingLottieThree;
